(function () {
  'use strict';

  var BAR_SCALE_FACTOR = 2;
  var SWEEP_DURATION = 2.3;
  var FOLD_OVERLAP = 0.6;
  var CONVERGE_DURATION = 1.7;
  var DEFAULT_COOKIE_NAME = 'hajime_opening_seen';
  var DEFAULT_COOKIE_DAYS = 1;

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].trim().split('=');
      if (parts[0] === name) return decodeURIComponent(parts[1]);
    }
    return null;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; expires=' + expires.toUTCString() + '; path=/';
  }

  function init() {
    var overlay = document.getElementById('opening-animation');
    if (!overlay) return;
    if (typeof gsap === 'undefined') {
      console.warn('[opening-animation] gsap not loaded; skipping animation');
      overlay.style.display = 'none';
      return;
    }

    var cookieName = overlay.dataset.cookieName || DEFAULT_COOKIE_NAME;
    var cookieDays = Number(overlay.dataset.cookieDays) || DEFAULT_COOKIE_DAYS;

    if (getCookie(cookieName)) {
      overlay.style.display = 'none';
      return;
    }

    document.body.style.overflow = 'hidden';
    playAnimation(overlay, cookieName, cookieDays);
  }

  function playAnimation(overlay, cookieName, cookieDays) {
    var logo = overlay.querySelector('.opening-logo');
    var graphic = document.getElementById('opening-graphic');
    var mark = document.getElementById('opening-mark');
    var full = document.getElementById('opening-full');
    if (!logo || !graphic || !mark || !full) {
      document.body.style.overflow = '';
      return;
    }

    var containerWidth = overlay.offsetWidth;
    var naturalWidth = Math.min(Math.round(containerWidth * 0.75), 320);
    var scaledBarWidth = naturalWidth * BAR_SCALE_FACTOR;
    var markOffset = scaledBarWidth - naturalWidth;
    var entryOffset = Math.round(containerWidth * 0.3);

    var barClone = graphic.cloneNode(true);
    var markClone = mark.cloneNode(true);
    barClone.removeAttribute('id');
    markClone.removeAttribute('id');
    barClone.classList.add('opening-sweep-clone');
    markClone.classList.add('opening-sweep-clone');
    graphic.parentNode.insertBefore(barClone, graphic);
    mark.parentNode.insertBefore(markClone, mark);

    gsap.set(barClone, {
      transformOrigin: 'left center',
      scaleX: BAR_SCALE_FACTOR,
      x: -(scaledBarWidth + entryOffset)
    });
    gsap.set(markClone, { x: -(scaledBarWidth + entryOffset) + markOffset });
    gsap.set(full, { x: -naturalWidth, opacity: 1 });

    var tl = gsap.timeline({
      onComplete: function () {
        document.body.style.overflow = '';
        setCookie(cookieName, '1', cookieDays);
        overlay.remove();
      }
    });

    tl.to(barClone, { x: containerWidth, duration: SWEEP_DURATION, ease: 'none' });
    tl.to(markClone, { x: containerWidth + markOffset, duration: SWEEP_DURATION, ease: 'none' }, '<');
    tl.to(full, { x: 0, duration: CONVERGE_DURATION, ease: 'power2.out' }, SWEEP_DURATION - FOLD_OVERLAP);
    tl.call(function () { barClone.remove(); markClone.remove(); }, null, SWEEP_DURATION);
    tl.to(logo, { opacity: 0, duration: 1.5, ease: 'none' }, '>+1.5');
    tl.to(overlay, { opacity: 0, duration: 0.75, ease: 'none' }, '>+0.5');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
